import { ExecutionMessage, NEW_ACTIVITY_EXECUTION_NAMESPACE } from '../reducers/activity-execution'
import { ProjectsService } from '@/app/services/ProjectsService'
import { setChartData, setSelectedStores } from './activity-approval'
import { FiltersService } from '@/app/services/FiltersService'
import {
    canAcceptExecution,
    canConfirmReadingNews,
    canExecuteJobTask,
    canExecuteQuestionTask,
    canExecuteSurveyTask,
    canUploadPhotoTask,
    CreateMessageBody,
    layoutActions,
    SmartlyActionItems,
    SmartlyActionSubtypes,
} from '@Techedge/digitalportal-shared'
import { resetAllForm } from './activity-creation'
import { chartStatusColors } from '@/app/utils/statusColorMap'
import { ForumService } from '@/app/services/ForumService'
import { TaskPhotoUpload } from '@/app/models/projects-service'
import { DelegatePayload } from '@/app/models/assignee'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '../reducers/activity-creation'

export const NewActivityExecutionActions = {
    UPDATE_MESSAGE_LIST: 'UPDATE_MESSAGE_LIST',
    SET_MESSAGE_LIST: 'SET_PROJECT_MESSAGE_LIST',
    SET_TOTAL_MESSAGE: 'SET_TOTAL_MESSAGE',
    SET_MESSAGE_PAGE_NUM: 'SET_MESSAGE_PAGE_NUM',
    SET_MESSAGE_LIST_LOADING: 'SET_PROJECT_MESSAGE_LIST_LOADING',
    SET_MESSAGE_CREATE_LOADING: 'SET_PROJECT_MESSAGE_CREATE_LOADING',
    SET_MESSAGE_REACTION_LOADING: 'SET_MESSAGE_REACTION_LOADING',
    REMOVE_MESSAGE: 'REMOVE_MESSAGE',
    SET_IS_APPROVAL: 'SET_IS_APPROVAL',
    SET_IS_MULTISTORE: 'SET_IS_MULTISTORE',
    SET_IS_FULLSCREEN: 'SET_IS_FULLSCREEN',
    SET_STORE_ID: 'SET_STORE_ID',
    SET_PROJECT_DETAILS: 'SET_PROJECT_DETAILS',
    GET_PROJECT_DETAILS_REQUEST: 'GET_PROJECT_DETAILS_REQUEST',
    GET_PROJECT_DETAILS_SUCCESS: 'GET_PROJECT_DETAILS_SUCCESS',
    GET_PROJECT_DETAILS_FAILURE: 'GET_PROJECT_DETAILS_FAILURE',
    GET_ASSIGNEES_REQUEST: 'GET_ASSIGNEES_REQUEST',
    GET_ASSIGNEES_SUCCESS: 'GET_ASSIGNEES_SUCCESS',
    GET_ASSIGNEES_FAILURE: 'GET_ASSIGNEES_FAILURE',
    ANSWER_QUESTION_REQUEST: 'ANSWER_QUESTION_REQUEST',
    ANSWER_QUESTION_SUCCESS: 'ANSWER_QUESTION_SUCCESS',
    ANSWER_QUESTION_FAILURE: 'ANSWER_QUESTION_FAILURE',
    SAVE_DELEGATION_REQUEST: 'SAVE_DELEGATION_REQUEST',
    SAVE_DELEGATION_SUCCESS: 'SAVE_DELEGATION_SUCCESS',
    SAVE_DELEGATION_FAILURE: 'SAVE_DELEGATION_FAILURE',
    EXECUTION_API_REQUEST: 'EXECUTION_API_REQUEST',
    EXECUTION_API_SUCCESS: 'EXECUTION_API_SUCCESS',
    EXECUTION_API_FAILURE: 'EXECUTION_API_FAILURE',
    GET_SURVEY_STATUS_REQUEST: 'GET_SURVEY_STATUS_REQUEST',
    GET_SURVEY_STATUS_SUCCESS: 'GET_SURVEY_STATUS_SUCCESS',
    GET_SURVEY_STATUS_ERROR: 'GET_SURVEY_STATUS_ERROR',
    SURVEY_LIST_DOWNLOAD_SUCCESS: 'SURVEY_LIST_DOWNLOAD_SUCCESS',
    SURVEY_LIST_DOWNLOAD_FAILURE: 'SURVEY_LIST_DOWNLOAD_FAILURE',
    GET_ACTIVITY_TASK_PHOTO: 'GET_ACTIVITY_TASK_PHOTO',
    GET_ACTIVITY_TASK_PHOTO_REQUEST: 'GET_ACTIVITY_TASK_PHOTO_REQUEST',
    GET_ACTIVITY_TASK_PHOTO_SUCCESS: 'GET_ACTIVITY_TASK_PHOTO_SUCCESS',
    GET_ACTIVITY_TASK_PHOTO_ERROR: 'GET_ACTIVITY_TASK_PHOTO_ERROR',
    RESET_ACTIVITY_TASK_PHOTO: 'RESET_ACTIVITY_TASK_PHOTO',
    SET_IS_PHOTOGRAPHIC_APPROVAL_ACCEPT: 'SET_IS_PHOTOGRAPHIC_APPROVAL_ACCEPT',
    ACCEPT_STORE_SUCCESS: 'ACCEPT_STORE_ACCEPT_SUCCESS',
}

// MESSAGING

export const updateMessageList = (index: number, message: Partial<ExecutionMessage>) => {
    return { type: NewActivityExecutionActions.UPDATE_MESSAGE_LIST, payload: { index, message } }
}
export const setMessageList = (messages: Partial<ExecutionMessage[]>) => {
    return { type: NewActivityExecutionActions.SET_MESSAGE_LIST, messages }
}
export const setTotalMessage = (totalMessage: number) => {
    return { type: NewActivityExecutionActions.SET_TOTAL_MESSAGE, totalMessage }
}
export const setMessagePageNum = (messagePageNum: number) => {
    return { type: NewActivityExecutionActions.SET_MESSAGE_PAGE_NUM, messagePageNum }
}
export const setMessageListLoading = (loading: boolean) => {
    return { type: NewActivityExecutionActions.SET_MESSAGE_LIST_LOADING, loading }
}
export const setMessageCreateLoading = (loading: boolean) => {
    return { type: NewActivityExecutionActions.SET_MESSAGE_CREATE_LOADING, loading }
}
export const setMessageReactionLoading = (loading: boolean) => {
    return { type: NewActivityExecutionActions.SET_MESSAGE_REACTION_LOADING, loading }
}

export const removeMessage = (index: number) => {
    return { type: NewActivityExecutionActions.REMOVE_MESSAGE, index }
}

// SET IS APPROVAL

export const setIsApproval = (value: boolean) => {
    return { type: NewActivityExecutionActions.SET_IS_APPROVAL, value }
}
export const setIsPhotographicApprovalAccept = (value: boolean) => {
    return { type: NewActivityExecutionActions.SET_IS_PHOTOGRAPHIC_APPROVAL_ACCEPT, value }
}

// SET IS MULTISTORE

export const setIsMultiStore = (value: boolean) => {
    return { type: NewActivityExecutionActions.SET_IS_MULTISTORE, value }
}

// SET IS FULLSCREEN

export const setIsFullScreen = (value: boolean) => {
    return { type: NewActivityExecutionActions.SET_IS_FULLSCREEN, value }
}

// SET STORE

export const setStoreId = (storeId: string) => {
    return { type: NewActivityExecutionActions.SET_STORE_ID, storeId }
}
export const setProjectDetails = (projectDetails) => {
    return { type: NewActivityExecutionActions.SET_PROJECT_DETAILS, projectDetails }
}

// GET PROJECT DETAILS

export const getProjectDetailsRequest = () => {
    return { type: NewActivityExecutionActions.GET_PROJECT_DETAILS_REQUEST }
}

export const getProjectDetailsError = (error?: any) => {
    return { type: NewActivityExecutionActions.GET_PROJECT_DETAILS_FAILURE, error }
}

export const getProjectDetailsSuccess = (projectDetails: any[]) => {
    return {
        type: NewActivityExecutionActions.GET_PROJECT_DETAILS_SUCCESS,
        projectDetails,
    }
}

export const getSurveyStatusRequest = () => {
    return { type: NewActivityExecutionActions.GET_SURVEY_STATUS_REQUEST }
}

export const getSurveyStatusSuccess = (success: any) => {
    return {
        type: NewActivityExecutionActions.GET_SURVEY_STATUS_SUCCESS,
        success,
    }
}

export const getSurveyStatusError = (error: any) => {
    return { type: NewActivityExecutionActions.GET_SURVEY_STATUS_ERROR, error }
}

const surveyListDownloadSuccess = () => {
    return {
        type: NewActivityExecutionActions.SURVEY_LIST_DOWNLOAD_SUCCESS,
        data: {},
        toastList: [
            {
                title: 'Success',
                text: 'Request processed successfully. The file will be sent to your email',
            },
        ],
    }
}
const surveyrListDownloadError = () => {
    return {
        type: NewActivityExecutionActions.SURVEY_LIST_DOWNLOAD_FAILURE,
        data: {},
        toastList: [{ title: 'Error', text: 'Request could not be processed.' }],
    }
}

// EXECUTION API
export const executionApiRequest = () => {
    return { type: NewActivityExecutionActions.EXECUTION_API_REQUEST }
}

export const executionApiError = (error?: any) => {
    return {
        type: NewActivityExecutionActions.EXECUTION_API_FAILURE,
        toastList: [
            {
                text: error,
            },
        ],
    }
}

export const executionApiSuccess = (text: string) => {
    return {
        type: NewActivityExecutionActions.EXECUTION_API_SUCCESS,
        toastList: [
            {
                text,
            },
        ],
    }
}

const calculateChartData = (data) => {
    return (dispatch: any) => {
        let totPercentage = 0
        let totStores = 0
        let chartData = {}
        data.storesList.forEach((store) => {
            totStores += 1
            chartData[store.status] = chartData[store.status] || { stores: 0 }
            chartData[store.status] = {
                stores: chartData[store.status].stores + 1,
            }
        })

        Object.keys(chartData).forEach((key, index) => {
            let percentage = Math.round((chartData[key].stores * 100) / totStores)
            totPercentage += percentage
            if (index === Object.keys(chartData).length - 1 && totPercentage !== 100)
                percentage += 1
            chartData[key] = {
                ...chartData[key],
                percentage,
                color: chartStatusColors[key],
                // color: chartColor[index],
            }
        })
        dispatch(setChartData(chartData))
    }
}

export const getSurveyStatus = (surveyId: string, storeId: string, projectId: string) => {
    return (dispatch: any, getState) => {
        dispatch(getSurveyStatusRequest())
        ProjectsService.GetSurveyStatus(surveyId, storeId, projectId)
            .then((res: any) => {
                if (res && res.data) {
                    dispatch(
                        getSurveyStatusSuccess({
                            ...getState()[NEW_ACTIVITY_EXECUTION_NAMESPACE].surveyStatusUpdateMap,
                            [surveyId]: res.data,
                        })
                    )
                }
            })
            .catch((error) => {
                dispatch(getSurveyStatusError(error))
            })
    }
}

export const reloadProjectStatus = (projectId: string, storeIds, callback?: (data?) => void) => {
    return (dispatch: any) => {
        dispatch(getProjectDetailsRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.GetProjectDetails(projectId, storeIds)
            .then((res: any) => {
                if (res && res.data) {
                    calculateChartData(res.data)
                    callback && callback(res.data)
                    dispatch(getProjectDetailsSuccess(res.data))
                }
            })
            .catch((error: any) => {
                dispatch(getProjectDetailsError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

export const hasAssignedJobs = (jobs, projectStatus) => {
    let hasJobs = false
    jobs.forEach((job) => {
        hasJobs =
            hasJobs ||
            canExecuteQuestionTask({
                status: projectStatus,
                module: 'communication',
                type: 'communication',
                assignment: job.assignment,
            })
    })
    return hasJobs
}

export const hasAssignedSurveys = (surveys, projectStatus) => {
    let hasSurveys = false
    surveys.forEach((survey) => {
        hasSurveys =
            hasSurveys ||
            canExecuteSurveyTask({
                status: projectStatus,
                module: 'communication',
                type: 'communication',
                assignment: survey.assignment,
            })
    })
    return hasSurveys
}

const hasDelegate = (stores) => {
    let result = false
    stores.forEach((s) => {
        result = result || s.isDelegate
    })
    return result
}

export const getVisitProjectDetails = (projectId: string, stores?: string[]) => {
    return (dispatch: any) => {
        dispatch(getProjectDetailsRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.GetProjectDetails(projectId, stores)
            .then((res: any) => {
                if (res && res.data && !res.data.output && !stores?.length) {
                    dispatch(getVisitProjectDetails(projectId, res.data.storesIdList))
                    return
                }
                if (res && res.data && !res.data.output) {
                    dispatch(getProjectDetailsSuccess(res.data))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                } else {
                    dispatch(getProjectDetailsError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(getProjectDetailsError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

export const getProjectDetails = (
    projectId: string,
    stores?: string[],
    isSendInApproval?: boolean
) => {
    return (dispatch: any, getState) => {
        dispatch(getProjectDetailsRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.GetProjectDetails(projectId, stores)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    // sma-850 summary chart visible also for single store
                    dispatch(setIsMultiStore(true))
                    let canExecute
                    if (res.data.projectType === SmartlyActionItems.TASK) {
                        canExecute =
                            isSendInApproval ||
                            canExecuteQuestionTask(res.data) ||
                            canExecuteJobTask(res.data) ||
                            canAcceptExecution(res.data.projectType, res.data) ||
                            canUploadPhotoTask(res.data) ||
                            canExecuteSurveyTask(res.data) ||
                            canConfirmReadingNews(res.data.projectType, res.data) ||
                            hasAssignedJobs(res.data.jobs, res.data.status) ||
                            hasAssignedSurveys(res.data.surveys, res.data.status) ||
                            hasDelegate(res.data.storesList) ||
                            !!res.data.assignmentUserIds?.find(
                                (u) => u === getState().userReducer.user?.user_id
                            ) ||
                            (
                                !!stores &&
                                res.data.storesList[0]?.executorUserInfo?.find(
                                    (u) => u.userId === getState().userReducer.user?.user_id
                                )
                            )?.isAccepted
                    } else {
                        canExecute = canConfirmReadingNews(res.data.projectType, res.data)
                    }
                    switch (res.data.type) {
                        case SmartlyActionSubtypes.COMMUNICATION:
                            canExecute =
                                canExecute ||
                                res.data.status === 'draft' ||
                                res.data.status === 'toBeReleased'
                            break
                        case SmartlyActionSubtypes.PICTURE_MGMT:
                        case SmartlyActionSubtypes.SERVICE_REQUEST:
                            canExecute = !res.data.canApproval
                            break
                        case SmartlyActionItems.VISIT:
                            canExecute =
                                res.data.creatorUserInfo.userId ===
                                getState().userReducer.user?.user_id
                        default:
                            break
                    }
                    dispatch(setIsApproval(!canExecute))
                    let totPercentage = 0
                    let totStores = 0
                    let chartData = {}
                    if (res.data.storesList && Array.isArray(res.data.storesList)) {
                        res.data.storesList.forEach((store) => {
                            totStores += 1
                            chartData[store.status] = chartData[store.status] || { stores: 0 }
                            chartData[store.status] = {
                                stores: chartData[store.status].stores + 1,
                            }
                        })
                    }

                    Object.keys(chartData).forEach((key, index) => {
                        let percentage = Math.round((chartData[key].stores * 100) / totStores)
                        totPercentage += percentage
                        if (index === Object.keys(chartData).length - 1 && totPercentage !== 100)
                            percentage += 1
                        chartData[key] = {
                            ...chartData[key],
                            percentage,
                            color: chartStatusColors[key],
                        }
                    })
                    dispatch(setChartData(chartData))
                    dispatch(getProjectDetailsSuccess(res.data))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                } else {
                    dispatch(getProjectDetailsError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(getProjectDetailsError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// GET ASSIGNEES

export const getAssigneesRequest = () => {
    return { type: NewActivityExecutionActions.GET_ASSIGNEES_REQUEST }
}

export const getAssigneesError = (error?: any) => {
    return { type: NewActivityExecutionActions.GET_ASSIGNEES_FAILURE, error }
}

export const getAssigneesSuccess = (assignees: any[]) => {
    return {
        type: NewActivityExecutionActions.GET_ASSIGNEES_SUCCESS,
        assignees,
    }
}

export const getAssignees = (
    storeId: string,
    profileList?: string[],
    role?: { isApproval: boolean; code: string; search?: string },
    callback?: () => void
) => {
    return (dispatch: any) => {
        dispatch(getAssigneesRequest())
        FiltersService.GetAssignees(storeId, profileList, role)
            .then((res: any) => {
                if (res && res.data && res.data.assignees) {
                    dispatch(getAssigneesSuccess(res.data.assignees))
                } else {
                    dispatch(getAssigneesError())
                }
            })
            .catch((error: any) => {
                dispatch(getAssigneesError(error.response?.data?.message || error.message))
            })
            .finally(() => {
                if (callback) callback()
            })
    }
}

export const markAsRead = (
    projectId: string,
    isRead: boolean,
    successMessage: string,
    storeIdList
) => {
    return (dispatch: any) => {
        dispatch(executionApiRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.MarkAsReadProject(projectId, isRead)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(executionApiSuccess(successMessage))
                    dispatch(getProjectDetails(projectId, storeIdList))
                } else {
                    dispatch(executionApiError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

export const saveAsToBeReleased = (projectId: string, successMessage: string, storeIdList) => {
    return (dispatch: any) => {
        dispatch(executionApiRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.SaveAsToBeReleased(projectId)
            .then((res: any) => {
                if (res && res.data && res.data && !res.data.output) {
                    dispatch(executionApiSuccess(successMessage))
                    dispatch(getProjectDetails(projectId, storeIdList))
                } else {
                    dispatch(executionApiError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// ANSWER QUESTION

export const answerQuestionRequest = () => {
    return { type: NewActivityExecutionActions.ANSWER_QUESTION_REQUEST }
}

export const answerQuestionError = (error?: any) => {
    return {
        type: NewActivityExecutionActions.ANSWER_QUESTION_FAILURE,
        toastList: [
            {
                text: error,
            },
        ],
    }
}

export const answerQuestionSuccess = (successMessage: string) => {
    return {
        type: NewActivityExecutionActions.ANSWER_QUESTION_SUCCESS,
        toastList: [
            {
                text: successMessage,
            },
        ],
    }
}

export const answerQuestion = (
    projectId: string,
    questionId: string,
    answer: string,
    jobId?: string,
    successMessage?: string,
    answerAttachments?: any[]
) => {
    return (dispatch: any, getState) => {
        dispatch(answerQuestionRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.AnswerQuestion(
            projectId,
            questionId,
            getState()[NEW_ACTIVITY_EXECUTION_NAMESPACE].storeId,
            answer,
            jobId,
            answerAttachments
        )
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(answerQuestionSuccess(successMessage))
                    dispatch(
                        reloadProjectStatus(projectId, [
                            getState()[NEW_ACTIVITY_EXECUTION_NAMESPACE].storeId,
                        ])
                    )
                } else {
                    dispatch(answerQuestionError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(answerQuestionError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
        // .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

// SAVE DELEGATION

export const saveDelegationRequest = () => {
    return { type: NewActivityExecutionActions.SAVE_DELEGATION_REQUEST }
}

export const saveDelegationError = (error?: any) => {
    return {
        type: NewActivityExecutionActions.SAVE_DELEGATION_FAILURE,
        toastList: [
            {
                text: error,
            },
        ],
    }
}

export const saveDelegationSuccess = (data: any) => {
    return {
        type: NewActivityExecutionActions.SAVE_DELEGATION_SUCCESS,
        toastList: [
            {
                text: 'Delegation saved successfully!',
            },
        ],
    }
}

export const saveDelegation = (
    projectId: string,
    storeId: string,
    delegateBody: DelegatePayload,
    successCallback: () => void
) => {
    return (dispatch: any) => {
        dispatch(saveDelegationRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.DelegateProject(projectId, delegateBody)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(saveDelegationSuccess(res.data))
                    dispatch(
                        reloadProjectStatus(
                            projectId,
                            storeId ? [storeId] : null
                            // delegateBody.storeInfoAssignees.map((s) => s.storeId)
                        )
                    )
                    successCallback()
                } else {
                    dispatch(saveDelegationError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(saveDelegationError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// RECALL PROJECT

export const recallProject = (projectId: string, successMessage: string) => {
    return (dispatch: any) => {
        dispatch(executionApiRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.RecallProject(projectId)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(executionApiSuccess(successMessage))
                    dispatch(resetAllForm())
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(executionApiError(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

// CANCEL PROJECT

export const cancelProject = (
    projectId: string,
    successMessage: string,
    body?: { macroreason: string; reason: string }
) => {
    return (dispatch: any) => {
        dispatch(executionApiRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.CancelProject(projectId, body)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(executionApiSuccess(successMessage))
                    dispatch(resetAllForm())
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(executionApiError(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

// TASK EMPTY ANSWER

export const taskEmptyAnswer = (
    projectId: string,
    storeId: string,
    answer: string,
    storeIdList: any[],
    successMessage: string
) => {
    return (dispatch: any) => {
        dispatch(executionApiRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.TaskEmptyAnswer(projectId, storeId, answer)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(executionApiSuccess(successMessage))
                    dispatch(getProjectDetails(projectId, storeIdList))
                } else {
                    dispatch(executionApiError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

export const createMessage = (body: CreateMessageBody, id?: string, index?: number) => {
    return (dispatch) => {
        dispatch(setMessageCreateLoading(true))
        ForumService.CreateMessage(body, id)
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(updateMessageList(index, { isEdit: false }))
                    dispatch(
                        getMessage({
                            projectId: body.reference.projectId,
                            pageNum: 1,
                            isDetail: true,
                        })
                    )
                } else {
                    dispatch(executionApiError(res.data.output.payload.message))
                    dispatch(setMessageCreateLoading(false))
                }
            })
            .catch((error: any) => {
                dispatch(setMessageCreateLoading(false))
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
    }
}

export const getMessage = ({ isLoadMore, ...params }: any) => {
    return (dispatch, getState) => {
        const pageNum =
            params.pageNum || getState()[NEW_ACTIVITY_EXECUTION_NAMESPACE].messagePageNum
        dispatch(setMessageListLoading(true))
        ForumService.GetMessageList({
            ...params,
            sortAction: 'ASC',
            pageNum,
            pageSize: 5,
        })
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(setTotalMessage(res.data.totalRecords))
                    const oldMessages = isLoadMore
                        ? getState()[NEW_ACTIVITY_EXECUTION_NAMESPACE].messageList
                        : []

                    dispatch(
                        setMessageList([
                            ...oldMessages,
                            ...res.data?.data?.map((m) => {
                                let reactionTypes = []
                                if (m.reactions) {
                                    m.reactions?.forEach((r) => {
                                        const selReact = reactionTypes.find(
                                            (rt) => r.reaction === rt
                                        )

                                        if (!selReact) reactionTypes.push(r.reaction)
                                    })
                                }

                                return {
                                    id: m._id,
                                    author: {
                                        name: m.creator.firstname,
                                        lastname: m.creator.lastname,
                                        alias: m.creator.nickname,
                                        nickname: m.creator?.userId,
                                        avatar: m.creator.attachment?.url,
                                    },
                                    creatorUser: m.creator,
                                    creationDate: m.creationDate,
                                    reason: m.reason,
                                    reactions: {
                                        typeList: m.reactions?.map((r) => r.reaction),
                                        total: m.reactions.length,
                                        userReaction: m.reactions?.find(
                                            (r) =>
                                                r.userInfo?.userId ===
                                                getState().userReducer.user.user_id
                                        )?.reaction,
                                    },
                                    commentsList: [],
                                    stores: m.reference?.storeList,
                                    storeList: m.reference?.storeList,
                                    message: m.text,
                                    attachmentList: m.attachments?.map((a) => ({
                                        ...a,
                                        file: {
                                            name: `${a.name}.${a.ext}`,
                                        },
                                    })),
                                    totalReply: m.reference.childIds.length,
                                }
                            }),
                        ])
                    )
                } else {
                    dispatch(executionApiError(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
            .finally(() => {
                dispatch(setMessageListLoading(false))
                dispatch(setMessageCreateLoading(false))
                dispatch(setMessageReactionLoading(false))
            })
    }
}

export const reactionMessage = (
    body: Partial<CreateMessageBody>,
    id: string,
    userReaction: string,
    reaction?: string
) => {
    return (dispatch) => {
        dispatch(setMessageReactionLoading(true))

        let reactionOperation = 'add'
        let newReaction
        if (!!reaction && userReaction === reaction) reactionOperation = 'remove'
        if (!!reaction && !!userReaction && userReaction !== reaction) {
            newReaction = reaction
            reaction = userReaction
            reactionOperation = 'remove'
        }

        ForumService.ReactionMessage(
            // @ts-ignore
            { ...body, reaction: reaction || body.reaction, reactionOperation },
            id
        )
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    if (newReaction) {
                        dispatch(
                            reactionMessage(
                                {
                                    reference: {
                                        projectId: body.reference.projectId,
                                        storeIdList: body.reference.storeIdList,
                                    },
                                    reaction: newReaction,
                                    // @ts-ignore
                                    reactionOperation: 'add',
                                },
                                id,
                                userReaction
                            )
                        )
                    } else {
                        dispatch(
                            getMessage({
                                projectId: body.reference.projectId,
                                isDetail: true,
                            })
                        )
                    }
                } else {
                    executionApiError(res.data.output.payload.message)
                }
            })
            .catch((error) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
    }
}

export const downloadSurveyList = (
    banner: string[],
    country: string[],
    type: 'SURVEY' | 'FORM'
) => {
    return (dispatch: any) => {
        ProjectsService.DownloadSurveyList(banner, country, type)
            .then(() => {
                dispatch(surveyListDownloadSuccess())
            })
            .catch(() => {
                dispatch(surveyrListDownloadError())
            })
    }
}
export const downloadVisitSurveyList = () => {
    return (dispatch: any, getState) => {
        ProjectsService.DownloadVisitSurveyList(
            getState()[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].visitActivity.form.mainInfo.storeId
                .value
        )
            .then(() => {
                dispatch(surveyListDownloadSuccess())
            })
            .catch(() => {
                dispatch(surveyrListDownloadError())
            })
    }
}

export const getActivityTaskRequest = () => {
    return { type: NewActivityExecutionActions.GET_ACTIVITY_TASK_PHOTO_REQUEST }
}
export const resetActivityTaskPhoto = () => {
    return { type: NewActivityExecutionActions.RESET_ACTIVITY_TASK_PHOTO }
}

export const getActivityTaskSuccess = (success: any) => {
    return {
        type: NewActivityExecutionActions.GET_ACTIVITY_TASK_PHOTO_SUCCESS,
        success,
    }
}

export const getActivityTaskError = (error: any) => {
    return { type: NewActivityExecutionActions.GET_ACTIVITY_TASK_PHOTO_ERROR, error }
}

export const getActivityTaskPhoto = (projectId: string, storeId: string, params) => {
    return (dispatch: any) => {
        dispatch(getActivityTaskRequest())
        ProjectsService.GetActivityTaskPhoto(projectId, storeId, params)
            .then((res: any) => {
                if (res && res.data) {
                    dispatch(getActivityTaskSuccess(res.data))
                }
            })
            .catch((error) => {
                dispatch(getActivityTaskError(error.response?.data?.message || error.message))
            })
    }
}

export const uploadActivityTaskPhoto = (photos: TaskPhotoUpload[], callback: () => void) => {
    return (dispatch: any) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.UploadActivityTaskPhoto(photos)
            .then((res: any) => {
                if (res && res.data) {
                    callback()
                }
            })
            .catch((error) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}
export const deleteActivityTaskPhoto = (attachmentsIds: string[], callback: () => void) => {
    return (dispatch: any) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.DeleteActivityTaskPhoto(attachmentsIds)
            .then((res: any) => {
                if (res && res.data) {
                    callback()
                }
            })
            .catch((error) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

export const acceptStoreSuccess = (text?: string) => {
    return {
        type: NewActivityExecutionActions.ACCEPT_STORE_SUCCESS,
        toastList: [
            {
                text: text || 'Store accepted successfully!',
            },
        ],
    }
}

export const acceptPhotographicTask = ({
    projectId,
    storeId,
    successMessage,
}: {
    projectId: string
    storeId: string
    successMessage: string
}) => {
    return (dispatch: any) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.AcceptPhotographicTask(projectId, storeId)
            .then((res: any) => {
                if (res && res.data) {
                    dispatch(acceptStoreSuccess(successMessage))
                    dispatch(getProjectDetails(projectId, [storeId]))
                } else {
                    executionApiError(res.data.output.payload.message)
                }
            })
            .catch((error) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

export const acceptApprovalPhotographicTask = ({
    projectId,
    storeIdList,
    successMessage,
    callback,
}: {
    projectId: string
    storeIdList: string[]
    successMessage: string
    callback: () => void
}) => {
    return (dispatch: any) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.AcceptApprovalPhotographicTask(projectId, storeIdList)
            .then((res: any) => {
                if (res && res.data) {
                    dispatch(acceptStoreSuccess(successMessage))
                    dispatch(setSelectedStores([]))
                    dispatch(getProjectDetails(projectId))
                    callback()
                } else {
                    executionApiError(res.data.output.payload.message)
                }
            })
            .catch((error) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

export const acceptApprovalServiceRequestApprovalDetail = ({
    projectId,
    storeIdList,
    successMessage,
}: {
    projectId: string
    storeIdList: string[]
    successMessage: string
}) => {
    return (dispatch: any) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.AcceptApprovalPhotographicTask(projectId, storeIdList)
            .then((res: any) => {
                if (res && res.data) {
                    dispatch(acceptStoreSuccess(successMessage))
                    dispatch(getProjectDetails(projectId, storeIdList))
                } else {
                    executionApiError(res.data.output.payload.message)
                }
            })
            .catch((error) => {
                dispatch(executionApiError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}
